import React from 'react'
import Employee from '../Components/Employee'

function EmployeePage() {
  return (
    <div className="bg-gradient-to-r from-blue-300 to-blue-400  min-h-screen"><Employee/></div>
  )
}

export default EmployeePage